import React, { createContext, useContext, useState } from "react";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";

interface RoleContextProps {
  triggerSaveChanges: () => void; 
  setRoleSave: any;
}

const RoleContext = createContext<RoleContextProps | undefined>(undefined);

export const RoleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [roleSave, setRoleSave] = useState<any>();
  console.log("saveChanges", roleSave);

  const triggerSaveChanges = () => {
      saveChanges(); 
  };

  const saveChanges =  () => {
    console.log("Save changes");
    const roleReq: any = {
        role_name: roleSave?.name,
        role_id: roleSave?.id,
        permissions: []
      };
    
      for (const [key, value] of Object.entries(roleSave?.permissions)) {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        const permissionObj: { code: string, value: string  } = { code: key, value: value.toString() };
        roleReq?.permissions.push(permissionObj);
        }
      }
    try {
        axiosInstance.post(END_POINTS.SAVE_USERS,  roleReq );
    } catch (error) {
      console.error('Save failed', error);
    }
  }

  return (
    <RoleContext.Provider value={{ triggerSaveChanges, setRoleSave }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRoleContext = () => {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error("useRoleContext must be used within a RoleProvider");
  }
  return context;
};